var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCopy = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "evenodd",
    d: "M11,8.25 L20,8.25 C21.5187831,8.25 22.75,9.48121694 22.75,11 L22.75,20 C22.75,21.5187831 21.5187831,22.75 20,22.75 L11,22.75 C9.48121694,22.75 8.25,21.5187831 8.25,20 L8.25,11 C8.25,9.48121694 9.48121694,8.25 11,8.25 Z M11,9.75 C10.3096441,9.75 9.75,10.3096441 9.75,11 L9.75,20 C9.75,20.6903559 10.3096441,21.25 11,21.25 L20,21.25 C20.6903559,21.25 21.25,20.6903559 21.25,20 L21.25,11 C21.25,10.3096441 20.6903559,9.75 20,9.75 L11,9.75 Z M5,14.25 C5.41421356,14.25 5.75,14.5857864 5.75,15 C5.75,15.4142136 5.41421356,15.75 5,15.75 L4,15.75 C2.48121694,15.75 1.25,14.5187831 1.25,13 L1.25,4 C1.25,2.48121694 2.48121694,1.25 4,1.25 L13,1.25 C14.5187831,1.25 15.75,2.48121694 15.75,4 L15.75,5 C15.75,5.41421356 15.4142136,5.75 15,5.75 C14.5857864,5.75 14.25,5.41421356 14.25,5 L14.25,4 C14.25,3.30964406 13.6903559,2.75 13,2.75 L4,2.75 C3.30964406,2.75 2.75,3.30964406 2.75,4 L2.75,13 C2.75,13.6903559 3.30964406,14.25 4,14.25 L5,14.25 Z"
  }));
};
export default SvgCopy;